<template>
  <section>
    <div class="form-content">

      <!-- <el-col :span="12"> -->
      <!-- </el-col> -->
      <div class="clear">
        <el-col :span="12" v-if="form.type==0">
          <el-form-item label="申请部门">
            <el-input size="small" :disabled="true" v-model="userData.childDept"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-else>
          <el-form-item label="申请单位">
            <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申请人">
            <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div class="clear">
        <el-col :span="12">
          <el-form-item label="采购项目">
            <el-input size="small" v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="type==0" label="招标方式">
            <el-select size="small" v-model="form.zbfs" placeholder="请选择招标方式">
              <el-option v-for="item in zbfsArr" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </div>


      <el-form-item label="关联工程(选填)">
        <el-select @change="forceUpdate" size="small" class="project-list-select" v-model="form.projectIds"
          filterable multiple placeholder="请选择">
          <el-option v-for="item in projectList" :key="item.id" :label="item.number+'-'+item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="采购内容">
        <section class="material-list">
          <div class="list-title">
            <div class="r">
              <el-button @click="AddMaterial()" type="primary" size="mini">添加采购内容</el-button>
            </div>
            <span class="tip">* 金额单位(元)</span>
          </div>
          <div class="material-table">
            <el-table :data="form.purchaseItems" border>
              <el-table-column prop="name" width="260" label="采购名称">
              </el-table-column>
              <el-table-column prop="spec" label="规格型号">
              </el-table-column>
              <el-table-column prop="amount" align="center" label="数量">
              </el-table-column>
              <el-table-column prop="price" align="center" label="单价">
              </el-table-column>
              <el-table-column prop="fee" align="center" label="金额">
              </el-table-column>
              <el-table-column prop="remark" align="center" label="备注">
              </el-table-column>

              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="点击变更信息" placement="bottom">
                    <i @click="MaterialChange(scope.row, scope.$index)"
                      class="iconfont icon-xiugai meeting-btn-icon  mbi-edit"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="点击删除" placement="bottom">
                    <i @click="MaterialDelete(scope.$index)"
                      class="iconfont icon-close meeting-btn-icon mbi-remove"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </section>
        <div class="total-price" v-if="form.priceNum">
          总价：<span>{{ form.priceNum }}</span> &nbsp;&nbsp;&nbsp;&nbsp;大写金额：<span>{{ form.price }}</span>
        </div>
      </el-form-item>
    </div>
    <!-- 添加采购项目 -->
    <div class="pop-room" v-if="addStatus">
      <a href="javascript:;" @click="addStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <!-- <h3 class="title">添加采购项目</h3> -->
        <el-col :span="22">
          <el-form ref="form" :model="mform" label-width="120px" class="form">
            <el-form-item label="*采购名称">
              <el-input size="small" v-model="mform.name"></el-input>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input size="small" v-model="mform.spec"></el-input>
            </el-form-item>
            <el-form-item label="*数量">
              <el-input size="small" type="number" v-model="mform.amount"></el-input>
            </el-form-item>
            <el-form-item label="*单价">
              <el-input size="small" type="number" v-model="mform.price"></el-input>
            </el-form-item>
            <el-form-item label="金额">
              <el-input size="small" :disabled="true" type="number" v-model="mform.fee"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input size="small" v-model="mform.remark"></el-input>
            </el-form-item>

            <el-form-item label="">
              <el-button @click="AddBtnClick()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </section>

</template>
<script>
  export default {
    props: ['formByFather', 'userData', 'type'],
    data() {
      return {
        form: {},

        // 子公司部们depid
        depIdSub: '',
        // 选择项目列表
        projectList: [],

        addType: 0,
        editIndex: '',
        mform: {
          name: '',
          spec: '',
          price: '',
          amount: 1,
          fee: '',
          remark: '',
        },
        zbfsArr: ["单一来源", "竞争性谈判", "邀请招标", "公开招标", "询比价招标"],

        addStatus: false,
        userDeptId: "",
      }
    },
    created() {
      ajax.get('/user/dept', '', (res) => {
        this.userDeptId = res.vo.array[0].id
        if (this.form.type == 0) {
          this.depIdSub = this.form.depId = this.userDeptId
        }
      })
    },
    mounted() {
      this.form = this.formByFather
      if (this.form.type == 0) {
        this.form.depId = this.depIdSub
      }

      // 获取项目列表
      this.getProjectList(() => {

      })
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 获取项目列表
      getProjectList(cb) {
        ajax.get('/contract/project/choose/list', {
          depId: ''
        }, (res) => {
          this.projectList = res.vo.array
          cb && cb()
        })
      },
      // 通过项目ID获取项目Name
      getProjectNameById() {
        let name = []
        for (let i = 0; i < this.form.projectIds.length; i++) {
          let _id = this.form.projectIds[i]
          for (let j = 0; j < this.projectList.length; j++) {
            if (this.projectList[j].id == _id) {
              name.push(this.projectList[j].name)
              break
            }
          }
        }
        return name.join(",")
      },

      // 编辑采购项目
      MaterialChange(row, index) {
        this.addType = 1
        this.editIndex = index
        this.mform = row
        this.addStatus = true
      },
      // 从列表里删除当前采购项目
      MaterialDelete(index) {
        this.form.purchaseItems.splice(index, 1)
      },
      // 显示添加采购项目弹窗
      AddMaterial() {
        // 初始化
        this.mform = {
          name: '',
          spec: '',
          price: '',
          amount: 1,
          fee: '',
          remark: '',
        }
        this.addType = 0
        this.addStatus = true
      },
      // 添加采购项目到列表
      AddBtnClick() {
        if (!this.mform.name || !this.mform.price || !this.mform.amount) {
          this.$message.error("请认真填写采购信息，带*为必填项")
          return
        }
        if (this.addType == 0) {
          this.form.purchaseItems.push(this.mform)
        } else {
          this.form.purchaseItems.splice(this.editIndex, 1, this.mform)
        }
        this.addStatus = false

        this.fixedTotalPrice()
      },
      // 返回form
      getFromData() {
        this.form.projectNames = this.getProjectNameById()
        return this.form
      },
      // 计算某项目总价
      fixedFee() {
        if (this.mform.price && this.mform.amount) {
          this.mform.fee = (this.mform.price * this.mform.amount).toFixed(2)
        }
      },
      // 计算真实总价
      fixedTotalPrice() {
        let _total = 0
        for (var i = 0; i < this.form.purchaseItems.length; i++) {
          _total += parseFloat(this.form.purchaseItems[i].fee)
        }
        this.form.priceNum = _total.toFixed(2)
        this.form.price = util.convertCurrency(this.form.priceNum)
      },
    },
    watch: {
      "mform.price"() {
        this.fixedFee()
      },
      "mform.amount"() {
        this.fixedFee()
      },
      "form.type"() {
        // type:0 部门  type:1 公司
        if (this.form.type == 1) {
          this.form.depId = this.userData.secDepIds.split(",")[0] / 1
        } else {
          this.form.depId = this.userDeptId
        }
      },
      formByFather() {
        this.form = this.formByFather
        if (this.form.type == 0) {
          this.form.depId = this.depIdSub
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/purchase/apply.vue